// extracted by mini-css-extract-plugin
export default {"logoSmallContainer":"Logos_logoSmallContainer__L0HwS","logoSmall":"Logos_logoSmall__wEuQW"};